"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.provinceOptions = exports.optionsWithoutSpouse = exports.optionsWithSpouse = exports.maritalStatusOptions = exports.genderOptions = exports.earningsTypeOptions = exports.dependentOptionsWithoutSpouse = exports.dependentOptionsWithSpouse = exports.coverageOptions = exports.categoryOptions = exports.accountStatusOptions = void 0;
var coverageOptions = exports.coverageOptions = [{
  key: 'Solo',
  value: 'Solo'
}, {
  key: 'Duo',
  value: 'Duo'
}, {
  key: 'Family',
  value: 'Family'
}];
var accountStatusOptions = exports.accountStatusOptions = [{
  key: '0',
  value: 'Pending'
}, {
  key: '1',
  value: 'Active'
}, {
  key: '2',
  value: 'Disabled'
}, {
  key: '8',
  value: 'Late Applicant'
}, {
  key: '9',
  value: 'Terminated'
}];
var earningsTypeOptions = exports.earningsTypeOptions = [{
  key: 'Hourly',
  value: 'Hourly'
}, {
  key: 'Salary',
  value: 'Salary'
}];
var optionsWithSpouse = exports.optionsWithSpouse = [{
  key: 'Child',
  value: 'Child'
}, {
  key: 'Spouse',
  value: 'Spouse'
}, {
  key: 'Common Law',
  value: 'Common Law'
}, {
  key: 'Parent',
  value: 'Parent'
}, {
  key: 'Sibling',
  value: 'Sibling'
}, {
  key: 'Grandchild',
  value: 'Grandchild'
}];
var optionsWithoutSpouse = exports.optionsWithoutSpouse = [{
  key: 'Child',
  value: 'Child'
}, {
  key: 'Common Law',
  value: 'Common Law'
}, {
  key: 'Parent',
  value: 'Parent'
}, {
  key: 'Sibling',
  value: 'Sibling'
}, {
  key: 'Grandchild',
  value: 'Grandchild'
}];
var dependentOptionsWithSpouse = exports.dependentOptionsWithSpouse = [{
  key: 'Spouse',
  value: 'Spouse'
}, {
  key: 'Child',
  value: 'Child'
}, {
  key: 'Common Law',
  value: 'Common Law'
}];
var dependentOptionsWithoutSpouse = exports.dependentOptionsWithoutSpouse = [{
  key: 'Child',
  value: 'Child'
}, {
  key: 'Common Law',
  value: 'Common Law'
}];
var provinceOptions = exports.provinceOptions = [{
  key: 'Alberta',
  value: 'Alberta'
}, {
  key: 'British Columbia',
  value: 'British Columbia'
}, {
  key: 'Manitoba',
  value: 'Manitoba'
}, {
  key: 'New Brunswick',
  value: 'New Brunswick'
}, {
  key: 'Newfoundland and Labrador',
  value: 'Newfoundland and Labrador'
}, {
  key: 'Northwest Territories',
  value: 'Northwest Territories'
}, {
  key: 'Nova Scotia',
  value: 'Nova Scotia'
}, {
  key: 'Nunavut',
  value: 'Nunavut'
}, {
  key: 'Ontario',
  value: 'Ontario'
}, {
  key: 'Prince Edward Island',
  value: 'Prince Edward Island'
}, {
  key: 'Quebec',
  value: 'Quebec'
}, {
  key: 'Saskatchewan',
  value: 'Saskatchewan'
}, {
  key: 'Yukon',
  value: 'Yukon'
}];
var genderOptions = exports.genderOptions = [{
  key: 'Female',
  value: 'Female'
}, {
  key: 'Male',
  value: 'Male'
}, {
  key: 'Other',
  value: 'Other'
}];
var maritalStatusOptions = exports.maritalStatusOptions = [{
  key: 'Never Married',
  value: 'Never Married'
}, {
  key: 'Married',
  value: 'Married'
}, {
  key: 'Common Law',
  value: 'Common Law'
}, {
  key: 'Divorced',
  value: 'Divorced'
}, {
  key: 'Widowed',
  value: 'Widowed'
}, {
  key: 'Separated',
  value: 'Separated'
}];
var categoryOptions = exports.categoryOptions = [{
  key: 'Chiropractor',
  value: 'Chiropractor'
}, {
  key: 'Dental',
  value: 'Dental'
}, {
  key: 'Drugs',
  value: 'Drugs'
}, {
  key: 'Eye Exam',
  value: 'Eye Exam'
}, {
  key: 'Generic Health',
  value: 'Generic Health'
}, {
  key: 'Massage',
  value: 'Massage'
}, {
  key: 'Naturopath',
  value: 'Naturopath'
}, {
  key: 'Orthotics',
  value: 'Orthotics'
}, {
  key: 'Osteopath',
  value: 'Osteopath'
}, {
  key: 'Physiotherapy',
  value: 'Physiotherapy'
}, {
  key: 'Podiatrist',
  value: 'Podiatrist'
}, {
  key: 'Psychologist',
  value: 'Psychologist'
}, {
  key: 'Speech',
  value: 'Speech'
}, {
  key: 'Vision',
  value: 'Vision'
}];